import type { SingleSignOnLoginStatus } from '@/types';

// The sso endpoints are same origin, so the session cookie is sent automatically.
async function postSso(url: string): Promise<Response> {
  return fetch(url, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  });
}

export async function fetchSsoLoginStatus(url: string): Promise<SingleSignOnLoginStatus | null> {
  try {
    const response = await postSso(url);
    if (!response.ok) {
      console.error('Failed to fetch sso login status: server returned', response.status);
      return null;
    }
    const data = await response.json();
    if (data?.status !== 'OK') {
      return null;
    }
    return data as SingleSignOnLoginStatus;
  } catch (e) {
    console.error('Failed to fetch sso login status:', e);
    return null;
  }
}

/** Used for the keep-alive (refresh) and for clearing the sso state in the shop session (logout). */
export async function callSsoEndpoint(url: string): Promise<boolean> {
  try {
    const response = await postSso(url);
    return response.ok;
  } catch (e) {
    console.error('Failed to call sso endpoint:', url, e);
    return false;
  }
}
